import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";
import { ExploreSelector } from "../components/ExploreSelector";
import { learnSections, widgetTypesList } from "../data/widgetsLists";

const SECTION_TO_KEY = {
  recipe: "recipe",
  "video-playlist": "videoPlaylist",
  "macro-calculator": "macroCalculator",
  store: "store",
  "file-documents": "fileDocuments",
  links: "links",
  "meal-plan-library": "mealPlanLibrary",
  "daily-accountability-template": "dailyAccountabilityTemplate",
};

const LearnMore = ({ section }) => {
  const { t } = useTranslation("coaching-portal");
  const sectionKey = SECTION_TO_KEY[section] || "recipe";
  const dataFromT = t("widgets.learnSections." + sectionKey, {
    returnObjects: true,
  });
  const data = learnSections[section] || learnSections.recipe;
  const title = typeof dataFromT === "object" ? dataFromT.title : data.title;
  const description =
    typeof dataFromT === "object" ? dataFromT.description : data.description;
  const howWork =
    typeof dataFromT === "object" && Array.isArray(dataFromT.howWork)
      ? dataFromT.howWork
      : data.howWork;
  const installDescription =
    typeof dataFromT === "object"
      ? dataFromT.installDescription
      : data.installDescription;
  return (
    <main className="widgets">
      <header>
        <hgroup className="widget-left-header mobile-hidden">
          <SvgIcon
            src={"/img/new-icons/back-button.svg"}
            onClickFn={() =>
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: { section: "", learn: "" },
              })
            }
          />
          <div>
            <h3>{t("widgets.widgetsMain.title")}</h3>
            <p className="p4">{t("widgets.widgetsMain.description")}</p>
          </div>
        </hgroup>
        <hgroup className="widget-left-header">
          <ExploreSelector
            widgetTypesList={widgetTypesList}
            defaultWidget={
              widgetTypesList[
                widgetTypesList.findIndex(
                  (widget) => widget.learnmoreLink === section
                )
              ] || widgetTypesList[0]
            }
          />
        </hgroup>
        <a
          href={`/actions/refresh?modal[type]=create-widget`}
          role="button"
          data-button-type="primary"
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          <span>{t("widgets.widgetsMain.addNewWidget")}</span>
        </a>
      </header>
      <section className="only-show-mobile back-handler">
        <SvgIcon
          src={"/img/new-icons/back-button.svg"}
          onClickFn={() =>
            submit(`/actions/refresh/?`, {
              method: "GET",
              body: { section: "", learn: "" },
            })
          }
        />
        <h3>{t("widgets.learnMore.explore")}</h3>
      </section>
      <section className="learn-more-container">
        <SvgIcon noFilterOnLight={true} src={data.banner} />
        <div>
          <div>
            <header>
              <h3>{title}</h3>
              <p className="p1">{description}</p>
            </header>
            <div>
              <p className="p6">{t("widgets.learnMore.howItWorks")}</p>
              <ul>
                {howWork.map((step, i) => (
                  <li key={i}>
                    <p className="p1">{step}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div>
            <p className="p6">{t("widgets.learnMore.icons")}</p>
            <div className="icons-container">
              {data.icons.map((icon, i) => (
                <SvgIcon key={i} src={icon} />
              ))}
            </div>
            <p className="p6">{installDescription}</p>
            <a
              role="button"
              data-button-type="outline"
              href={`/actions/refresh?modal[type]=install-widget&widgetModal[type]=${section}`}
              sz="large"
            >
              <span>{t("widgets.learnMore.installNow")}</span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LearnMore;
